module.exports = __webpack_public_path__ + "static/media/10.ade378e1.mp4";